import CityPageTemplate from "../city-template/CityPageTemplate";
import { kokomoConfig } from "./data";

export default function KokomoPage() {
  return <CityPageTemplate config={kokomoConfig} />;
}